@use "../../../sass/variables/colors" as colors;
@use "../../../sass/mixins/font-family" as typography;
@use "../../../sass/mixins/nimbus" as nimbus;

@keyframes nb-all-in-one-detail-fade-in {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

ux-iws-nb-all-in-one-detail {
    display: none;
    align-items: stretch;
    justify-content: stretch;
    position: relative;
    box-sizing: border-box;
    padding: 0;
    width: 100%;
    @include typography.font(light);
    @include nimbus.nb-cta-blue-background();

    * {
        box-sizing: border-box;
    }

    h2,
    h3,
    h4 {
        @include nimbus.nb-heading(4, light);
        margin: 0;
        color: inherit;
    }

    p {
        @include typography.font(light);
        font-size: 16px;
        line-height: 1.2;
        margin: 0;
        color: inherit;
    }

    p:not(:last-of-type) {
        margin-bottom: 1em;
    }

    ul {
        margin: 0;
        padding: 0 0 0 1em;
        list-style: square;

        @media (min-width: 1600px) {
            padding-left: 2em;
            border-left: 1px solid rgba(255, 255, 255, 0.2);
        }
    }

    li {
        @include typography.font(light);
        margin-bottom: 1em;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .is-hidden {
        display: none;
    }
}

.ux-iws-nb-all-in-one-detail {
    &__grid {
        position: relative;
        padding: 15px 15px 30px;
        width: 100%;
        display: block;

        @media (min-width: 768px) {
            padding: 30px;
        }

        @media (min-width: 1024px) {
            padding: 30px 60px;
        }
    }

    &__image {
        grid-area: image;
        width: 100%;

        img {
            display: block;
            width: 100%;
            max-width: 640px;
            height: auto;
            object-fit: cover;
            aspect-ratio: 16 / 9;
        }
    }

    &__content {
        grid-area: content;
    }

    &__title,
    &__text {
        @include typography.font(light);
        line-height: 1.2;
        margin: 0;
        max-width: 1000px;

        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    &__title {
        font-size: 20px;
    }

    &__text,
    &__text p {
        @include nimbus.nb-text(normal);
        color: inherit;
    }

    &__tag-list {
        @include nimbus.nb-tag-list();
        margin: 0;
    }

    &__tag {
        @include nimbus.nb-tag();
    }

    &__features {
        @include nimbus.nb-text(small);
        color: inherit;
        grid-area: features;
        display: flex;
        flex-flow: column nowrap;
        align-items: flex-start;
        justify-content: flex-start;
        width: 100%;
    }

    &__specs {
        @include nimbus.nb-text(small);
        color: inherit;
        grid-area: specs;
    }

    &__cta {
        grid-area: cta;
        display: flex;
        flex-flow: row nowrap;
        align-items: flex-start;
        justify-content: flex-start;
        width: 100%;
    }
}

ux-iws-nb-all-in-one-detail[active] {
    display: block;
    animation: nb-all-in-one-detail-fade-in 0.5s ease-in-out;
    animation-fill-mode: forwards;
}

.ux-iws-nb-all-in-one-detail__grid.ux-iws-nb-all-in-one-detail__grid--text {
    display: grid;
    max-width: 1200px;
    gap: 30px;
    grid-template-columns: auto;
    grid-template-rows: auto;
    grid-template-areas:
        "content"
        "cta";

    .ux-iws-nb-all-in-one-detail__text,
    .ux-iws-nb-all-in-one-detail__text p {
        @include nimbus.nb-heading(5, false);
        color: inherit;
    }
}

.ux-iws-nb-all-in-one-detail__grid.ux-iws-nb-all-in-one-detail__grid--image-text {
    display: grid;
    gap: 30px;
    grid-template-columns: auto;
    grid-template-rows: auto;
    grid-template-areas:
        "image"
        "content"
        "cta";

    @media (min-width: 768px) {
        gap: 30px;
        grid-template-columns: 3fr 4fr;
        grid-template-rows: 1fr auto;
        grid-template-areas:
            "image content"
            "image cta";
    }

    @media (min-width: 1440px) {
        max-width: 1600px;
        grid-template-columns: 2fr 3fr;
        grid-template-rows: 1fr auto;
        grid-template-areas:
            "image content"
            "image cta";
    }
}

.ux-iws-nb-all-in-one-detail__grid.ux-iws-nb-all-in-one-detail__grid--image-text-features {
    display: grid;
    gap: 30px;
    grid-template-columns: auto;
    grid-template-rows: auto;
    grid-template-areas:
        "content"
        "image"
        "features"
        "specs"
        "cta";

    @media (min-width: 768px) {
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto 1fr auto auto;
        grid-template-areas:
            "content content"
            "image features"
            "specs features"
            "cta cta";

        .ux-iws-nb-all-in-one-detail__image img {
            aspect-ratio: 1 / 1;
        }
    }

    @media (min-width: 900px) {
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto 1fr auto auto;
        grid-template-areas:
            "content content"
            "image features"
            "image cta"
            "specs specs";
    }

    @media (min-width: 1200px) {
        grid-template-columns: 2fr 3fr;
        grid-template-rows: auto auto 1fr auto;
        grid-template-areas:
            "content content"
            "image features"
            "image specs"
            "image cta";
    }

    @media (min-width: 1600px) {
        grid-template-columns: 2fr 3fr 2fr;
        grid-template-rows: 1fr auto auto;
        grid-template-areas:
            "image content features"
            "image specs features"
            "image cta features";

        .ux-iws-nb-all-in-one-detail__features {
            justify-content: center;
        }
    }
}

/* Full width button on mobile */
@media (max-width: 567px) {
    ux-iws-nb-all-in-one-detail [slot="cta"],
    ux-iws-nb-all-in-one-detail ux-button {
        width: 100%;
    }
}
